export default "__VITE_ASSET__C0E2z_hU__"